<template>
  <WorkerTypeTag :worker="worker" />
  <router-link
    v-if="withLink"
    class="mx-1"
    :to="{ name: 'worker-manage', params: { workerId: worker.id } }"
    target="_blank"
  >
    {{ worker.name }}
  </router-link>
  <span
    class="mx-1"
    v-else
    >{{ worker.name }}</span
  >
</template>

<script lang="ts">
import { type PropType, defineComponent } from 'vue'

import type { Worker } from '@/types/worker'

import WorkerTypeTag from './WorkerTypeTag.vue'

export default defineComponent({
  components: {
    WorkerTypeTag,
  },
  props: {
    worker: {
      type: Object as PropType<Worker>,
      required: true,
    },
    /**
     * Make the worker name clickable to open the worker details page in a new tab
     */
    withLink: {
      type: Boolean,
      default: false,
    },
  },
})
</script>
